import { render, staticRenderFns } from "./showShop.vue?vue&type=template&id=f51df6c6"
import script from "./showShop.vue?vue&type=script&lang=js"
export * from "./showShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports